const states = [
  { value: 0x1, description: "Alaska" },
  { value: 0x2, description: "Alabama" },
  { value: 0x4, description: "Arkansas" },
  { value: 0x8, description: "Arizona" },
  { value: 0x10, description: "California" },
  { value: 0x20, description: "Colorado" },
  { value: 0x40, description: "Connecticut" },
  { value: 0x80, description: "Delaware" },
  { value: 0x100, description: "Florida" },
  { value: 0x200, description: "Georgia" },
  { value: 0x400, description: "Hawaii" },
  { value: 0x800, description: "Iowa" },
  { value: 0x1000, description: "Idaho" },
  { value: 0x2000, description: "Illinois" },
  { value: 0x4000, description: "Indiana" },
  { value: 0x8000, description: "Kansas" },
  { value: 0x10000, description: "Kentucky" },
  { value: 0x20000, description: "Louisiana" },
  { value: 0x40000, description: "Massachusetts" },
  { value: 0x80000, description: "Maryland" },
  { value: 0x100000, description: "Maine" },
  { value: 0x200000, description: "Michigan" },
  { value: 0x400000, description: "Minnesota" },
  { value: 0x800000, description: "Missouri" },
  { value: 0x1000000, description: "Mississippi" },
  { value: 0x2000000, description: "Montana" },
  { value: 0x4000000, description: "North Carolina" },
  { value: 0x8000000, description: "North Dakota" },
  { value: 0x10000000, description: "Nebraska" },
  { value: 0x20000000, description: "New Hampshire" },
  { value: 0x40000000, description: "New Jersey" },
  { value: 0x80000000, description: "New Mexico" },
  { value: 0x100000000, description: "Nevada" },
  { value: 0x200000000, description: "New York" },
  { value: 0x400000000, description: "Ohio" },
  { value: 0x800000000, description: "Oklahoma" },
  { value: 0x1000000000, description: "Oregon" },
  { value: 0x2000000000, description: "Pennsylvania" },
  { value: 0x4000000000, description: "Rhode Island" },
  { value: 0x8000000000, description: "South Carolina" },
  { value: 0x10000000000, description: "South Dakota" },
  { value: 0x20000000000, description: "Tennessee" },
  { value: 0x40000000000, description: "Texas" },
  { value: 0x80000000000, description: "Utah" },
  { value: 0x100000000000, description: "Virginia" },
  { value: 0x200000000000, description: "Vermont" },
  { value: 0x400000000000, description: "Washington" },
  { value: 0x8000000000000, description: "Wisconsin" },
  { value: 0x1000000000000, description: "West Virginia" },
  { value: 0x2000000000000, description: "Wyoming" }
];

export { states };
